<template>
    <div ref="TeamPkRef" id="team-pk">
        <div class="poster" ref="poster">
            <img src="@/assets/active/team-pk/poster.png" alt="">
        </div>
        <div class="nav-wrapper" ref="TabBar">
            <router-link to="rule">
                <div class="nav" :class="activeTab === 'rule' ? 'active' : ''" @click="changeTab('rule')">
                    <span class="title">活动规则</span>
                </div>
            </router-link>
            <router-link to="member">
                <div class="nav" :class="activeTab === 'member' ? 'active' : ''" @click="changeTab('member')">
                    <span class="title">战队成员</span>
                </div>
            </router-link>
            <router-link to="live">
                <div class="nav" :class="activeTab === 'live' ? 'active' : ''" @click="currentTime >= beginTime ? changeTab('live') : null">
                    <span class="title">赛况直播</span>
                    <span v-if="!(currentTime >= beginTime)" class="sub-title">(即将开始)</span>
                </div>
            </router-link>
            <router-link to="result">
                <div class="nav" :class="activeTab === 'result' ? 'active' : ''" @click="currentTime >= beginTime ? changeTab('result') : null">
                    <span class="title">比赛结果</span>
                    <span v-if="!(currentTime >= beginTime)" class="sub-title">(即将开始)</span>
                </div>
            </router-link>
        </div>
        <router-view :class="isFixed" class="router" />
    </div>
</template>

<script>
export default {
    name: 'TeamPk',
    data() {
        return {
            activeTab: 'rule',
            currentTime: null,
            lastTime: null,
            beginTime: null,
            endTime: 1601367125000,
            state: null,
            isFixed: null
        }
    },
    mounted() {
        this.getList()
        this.activeTab = this.$route.path.split('/team-pk/')[1]
        let _this = this;
        window.onscroll = ()=> {
            if(_this.$refs.TabBar.offsetTop <= document.documentElement.scrollTop + 1){
                _this.$refs.TabBar.classList.add('fixed');
                _this.isFixed = 'fix'
            }
            if(_this.$refs.poster.clientHeight >= document.documentElement.scrollTop){
                _this.$refs.TabBar.classList.remove('fixed');
                _this.isFixed = ''
            }
        }
        setInterval(() => {
            this.currentTime = Math.round(new Date())
        }, 1000);
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab
        },
        //  获取活动基础信息
        getList() {
            this.$MyAxios.get('/api/trade/teams/rank', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    const data = response.data[0]
                    this.state = data.busStateName
                    this.lastTime = parseInt(data.lastModifiedDate)
                    this.beginTime = parseInt(data.busStartTimeOne)
                    this.endTime = parseInt(data.busEndTimeOne)
                }
            })
        },
    },
    beforeRouteUpdate (to, from, next) {
        if(to.name === 'TeamPkResult' || to.name === 'TeamPkLive') {
            if(this.currentTime >= this.beginTime) {
                next()
            } else {
                return
            }
        } else {
            next()
        }
    }
}
</script>

<style lang='less' scoped>
#team-pk {
    min-height: 100vh;
    background: #ffffff;
    .fix {
        padding-top: 100px;
        
    }
    .router {
        min-height: ~'calc(100vh - 440px)';
    }
}
.poster {
    width: 100vw;
    height: 440px;
    position: relative;
    img {
        height: 100%;
        width: 100%;
    }
}
.nav-wrapper {
    width: 100vw;
    height: 100px;
    position: relative;
    border-bottom: 1px solid #EBECF0;
    background: #ffffff;
    &.fixed {
        position: fixed;
        top: 0px;
        z-index: 1;
    }
    .nav {
        float: left;
        width: 25vw;
        height: 100px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding: 14px 0;
        // span {
        //     display: inline-block;
        //     width: 144px;
        // }
        .title {
            font-size: 28px;
            line-height: 36px;
            color: #33333A;
            font-weight: 700;
            vertical-align: middle;
        }
        .sub-title {
            color: #9598A6;
            font-size: 28px;
        }
        &.active {
            background: #FFF6E8;
            .title {
                color: #FFA41F;
            }
            &::after {
                content: '';
                position: absolute;
                height: 4px;
                width: 100%;
                bottom: 0px;
                left: 0;
                background: #FFA41F;
            }
            &::before {
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                border: 14px solid transparent;
                border-bottom-color: #FFA41F;
                left: 50%;
                margin-left: -7px;
                bottom: 0;
            }
        }

    }
}
</style>